<template>
  <div class="grid p-3 surface-100 w-full" role="status" aria-label="Loading items" aria-busy="true">
    <div v-for="index in count" :key="index" :class="itemClass" aria-hidden="true">
      <div class="min-w-0 border-round p-2 bg-white h-full flex flex-column">
        <Skeleton v-if="showMedia" height="15rem" class="w-full flex-shrink-0" />
        <div class="w-full min-w-0 my-3 px-3 sm:px-4 flex flex-column gap-2">
          <div v-if="infoColumns.length" class="flex flex-wrap align-items-center gap-2">
            <div
              v-for="(column, columnIndex) in infoColumns"
              :key="column.field ?? columnIndex"
              class="flex align-items-center gap-2"
            >
              <Skeleton
                shape="circle"
                :size="column.layout === 'person' ? '1.75rem' : '0.5rem'"
              />
              <Skeleton :width="column.layout === 'person' ? '7rem' : '5rem'" height="0.75rem" />
            </div>
          </div>
          <Skeleton width="90%" height="1.25rem" />
          <Skeleton width="65%" height="1.25rem" />
          <div class="flex flex-column gap-2">
            <Skeleton height="0.75rem" />
            <Skeleton height="0.75rem" />
            <Skeleton width="75%" height="0.75rem" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from 'primevue/skeleton'

defineProps({
  count: { type: Number, default: 6 },
  itemClass: { type: String, default: 'col-12 xl:col-4 p-1' },
  showMedia: { type: Boolean, default: true },
  infoColumns: { type: Array, default: () => [{}] },
})
</script>
